import React from 'react'
import { useField, Field, useFormik, useFormikContext } from 'formik'
import classNames from 'classnames'
import { twMerge } from 'tailwind-merge'

import { InputContainer, Switch as SwitchStyled } from './styles'

export function Switch({
    label, id, ...props 
}) {
    const [field, meta] = useField(props)

    if(!id) {
        throw new Error('Switches must have the "id" attribute.')
    }
    
    return (
        <div className="checkbox-container">
            <InputContainer>
                <SwitchStyled type="checkbox" id={id} {...field} {...props} />
                <label htmlFor={id}><span /></label>
                <span>{label}</span>
            </InputContainer>

            {meta.touched && meta.error 
                ? <span className="error">{meta.error}</span>
                : null}
        </div>
    )
}

export function Switch2({ label, trueValue, falseValue, name, className, ...props }) {
	const [field] = useField(props)

	const currentValue = field.value[name]

	return (
		<div className={twMerge('flex gap-2 items-center', className)}>
			{label && (
				<span className="text-xs">{label}</span>
			)}

			<label htmlFor={name} className="w-fit rounded-md flex items-center border border-white overflow-hidden cursor-pointer">
					<div 
						className={classNames('w-fit p-2', {
							'bg-red-500': !currentValue
						})}
					>
						Não
					</div>

					<div 
						className={classNames('w-fit p-2', {
							'bg-emerald-500': currentValue
						})}
					>
						Sim
					</div>
			</label>

			<Field 
				id={name} 
				name={name} 
				{...props} 
				type="checkbox" 
				style={{
					display: 'none'
				}}
			/>
		</div>
	)
}

export function Switch3({ label, name, className, items, ...props }) {
    const [field] = useField({ ...props, name })
    const { setFieldValue } = useFormikContext()
    
    function handleSetValue(e, newValue) {
        setFieldValue(name, newValue)

        field.onChange(e)
    }

    const colors = ['#ef5350', '#0284c7', '#66bb6a', '#f00']
    const selectedElement = field.value

	return (
        <div>
            <div className="flex w-fit cursor-pointer">
                {items.map((item, idx) => (
                    <div 
                        key={item} 
                        onClick={e => handleSetValue(e, idx)}
                        className={twMerge(
                            classNames('px-3 py-2 opacity-70 first:rounded-l-md last:rounded-r-md', {
                                [`opacity-100 bg-[${colors[idx]}] font-semibold`]: selectedElement === idx,
                                'border border-gray-300 hover:opacity-100 hover:font-semibold': selectedElement !== idx
                            })
                        )}
                    >
                        {item}
                    </div>
                ))}
            </div>

            <Field
				name={name} 
				{...props}
                {...field}
				type="hidden"
			/>
        </div>
    )
}
